"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const buildRoutingFunction_1 = __importDefault(require("../../shared/buildRoutingFunction"));
const executeTransition_1 = __importDefault(require("../../shared/executeTransition"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const AppStateConstants_1 = require("../../types/AppStateConstants");
const buildReplacePage = (0, buildRoutingFunction_1.default)({
    execute: ({ pageId, transition, store, params, }) => {
        if (!(0, valueIsString_1.default)(pageId)) {
            return;
        }
        store.dispatch({
            type: AppStateConstants_1.AppStateConstants.ROUTING_PUSH,
            payload: {
                pageId,
                transition,
                params,
            },
        });
        if (transition === null || transition === void 0 ? void 0 : transition.type) {
            store.dispatch({
                type: AppStateConstants_1.AppStateConstants.ROUTING_SET_CURRENT_ROUTE_TRANSITION,
                payload: transition,
            });
            (0, executeTransition_1.default)(transition === null || transition === void 0 ? void 0 : transition.speed)
                .then(() => {
                store.dispatch({
                    type: AppStateConstants_1.AppStateConstants.ROUTING_CLEAR_AFTER_REPLACE_ANIMATION,
                });
            });
            return;
        }
        store.dispatch({
            type: AppStateConstants_1.AppStateConstants.ROUTING_CLEAR_AFTER_REPLACE_ANIMATION,
        });
    },
    functionName: 'replacePage',
});
exports.default = buildReplacePage;
